import styled from 'styled-components';
import { StyledModalEditableName } from '../ModalEditableName/styled';

export const StyledModalEditableBody = styled(StyledModalEditableName).attrs({
  as: 'textarea',
})`
  outline: none;
  resize: none;
  padding: ${(p) => p.theme.space[6]};
  box-shadow: none;
  line-height: ${(p) => p.theme.space[4]};
  border-radius: ${(p) => p.theme.space[0]};
`;
